
const state = {
    surveyList:{},
    surveyDetail:{},
    lstQuestions:[],
  }
  
  const mutations = {
      getSurveyList(state, data){
        state.surveyList = data || ''
      },
      getSurveyDetail(state, data){
        state.surveyDetail = data || ''
      },
      getLstQuestions(state, data){
        state.lstQuestions = data
      }
  }
  
  export default {
    state,
    mutations,
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/research.js